<template lang="pug">
  div(:key="$route.params.slug")
    content-loader.mt-3(v-if="$wait.is('fetching page content')")
    div(v-if="!$wait.is('fetching page content') && page")
      div(v-html="page.content" v-if="!page.is_elementor")
      div(v-if="page.is_elementor")
        elementor-component(:object-id="page.ID" object-type="template")
</template>

<script>
import { ContentLoader } from 'vue-content-loader';
import BreadcrumbsManager from '../../mixins/BreadcrumbsManager';
import ElementorComponent from '../../components/ElementorComponent.vue';
import { RepositoryFactory } from '../../repositoryFactory';
import TitleManager from "../../mixins/TitleManager";

const BlogRepository = RepositoryFactory.get('blog');
export default {
  components: {
    ContentLoader,
    ElementorComponent,
  },
  mixins: [BreadcrumbsManager, TitleManager],
  data() {
    return {
      page: {},
    };
  },
  metaInfo() {
    return {
      title: this.$store.state.title.title,
    };
  },
  watch: {
    $route() {
      this.page = {};
      this.getPage();
    },
  },
  mounted() {
    this.getPage();
  },
  methods: {
    async getPage() {
      this.$wait.start('fetching page content');
      const { data } = await BlogRepository.page().getBySlug(this.$route.params.slug).then((resp) => resp.data);
      this.page = data;
      this.setBreadcrumbs([
        { name: this.page.post_title },
      ]);
      this.setTitle(this.page.post_title);
      this.$wait.end('fetching page content');
    },
  },
};
</script>
